import type { ToleranceArea } from './project-controls.js';

/** Who decides a Change Request. EXCEPTION is a project-tolerance break for the business layer. */
export const ChangeAuthority = {
  ProjectManager: 'PROJECT_MANAGER',
  ChangeAuthority: 'CHANGE_AUTHORITY',
  ProjectBoard: 'PROJECT_BOARD',
  Exception: 'EXCEPTION',
} as const;
export const ChangeAuthorityValues = Object.values(ChangeAuthority);
export type ChangeAuthority = (typeof ChangeAuthority)[keyof typeof ChangeAuthority];

export const ChangeRequestStatus = {
  Pending: 'PENDING',
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
} as const;
export const ChangeRequestStatusValues = Object.values(ChangeRequestStatus);
export type ChangeRequestStatus = (typeof ChangeRequestStatus)[keyof typeof ChangeRequestStatus];

export const ExceptionReportScope = {
  Stage: 'STAGE',
  Project: 'PROJECT',
} as const;
export const ExceptionReportScopeValues = Object.values(ExceptionReportScope);
export type ExceptionReportScope = (typeof ExceptionReportScope)[keyof typeof ExceptionReportScope];

export interface ProjectChangeRequestDto {
  id: string;
  issueId: string | null;
  stageId: string | null;
  title: string;
  description: string | null;
  costImpact: number;
  timeImpactDays: number | null;
  riskImpact: string | null;
  businessCaseImpact: string | null;
  authority: ChangeAuthority;
  status: ChangeRequestStatus;
  version: number;
  submittedByUserId: string;
  decidedByUserId: string | null;
  decidedAt: string | null;
  rationale: string | null;
  createdAt: string;
  updatedAt: string;
  /** Set on a write. Null on a read. */
  auditEventId: string | null;
}

export interface CreateProjectChangeRequestDto {
  title: string;
  description?: string | null;
  issueId?: string | null;
  stageId?: string | null;
  costImpact: number;
  timeImpactDays?: number | null;
  riskImpact?: string | null;
  businessCaseImpact?: string | null;
}

export interface DecideProjectChangeRequestDto {
  expectedVersion: number;
  expectedGovernanceVersion: number;
  decision: 'APPROVED' | 'REJECTED';
  rationale: string;
}

export interface SetChangeAuthorityDto {
  expectedVersion: number;
  pmChangeLimit: number | null;
  changeAuthorityLimit: number | null;
  changeBudget: number | null;
}

export interface RaiseExceptionReportDto {
  expectedVersion: number;
  scope: ExceptionReportScope;
  cause: string;
  impact: string;
  threatenedAreas: ToleranceArea[];
  options: string;
  recommendation: string;
  summary?: string | null;
  proposedBaselineBudget?: number | null;
  proposedStageId?: string | null;
  proposedPlannedBudget?: number | null;
  proposedPlannedStart?: string | null;
  proposedPlannedEnd?: string | null;
}

export interface ExceptionReportSnapshot {
  scope: ExceptionReportScope;
  cause: string;
  impact: string;
  threatenedAreas: ToleranceArea[];
  options: string;
  recommendation: string;
  proposedBaselineBudget?: number | null;
  proposedStageId?: string | null;
  proposedPlannedBudget?: number | null;
  proposedPlannedStart?: string | null;
  proposedPlannedEnd?: string | null;
}
